import React from "react";
import ReactDOM from "react-dom";
import App from "./components/app";
import * as serviceWorker from "./serviceWorker";
import "bootstrap/dist/css/bootstrap.css";
import "prismjs/themes/prism.css";
import "prismjs/themes/prism-solarizedlight.css";
//import "prismjs/themes/prism-tomorrow.css";
//prism-tomorrow prism-twilight prism-coy prism-dark
//import "./assets/fonts/inter-web/inter.css";
import "./index.css";

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
